import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppDialog({
  show,
  onChangeShow = (val) => { },
  showClose = true,
  children,
  bgColor,
  fullScreen: fullScreenProp,
  PaperProps: paperPropsProp,
  ...props
}) {
  const theme = createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            background:
              bgColor ||
              "linear-gradient(193.68deg, #003B6A -6.28%, #021024 101.79%)",
          },
        },
      },
    },
  });
  const [open, setOpen] = React.useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), {
    noSsr: true,
  });
  const fullScreen = fullScreenProp ?? isMobile;
  React.useEffect(() => {
    setOpen(show);
  }, [show]);

  const handleClose = (_, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    setOpen(false);
    onChangeShow(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        {...props}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          ...paperPropsProp,
          sx: {
            ...(fullScreen
              ? {
                  m: 0,
                  width: "100%",
                  height: "100%",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  borderRadius: 0,
                }
              : {}),
            ...paperPropsProp?.sx,
          },
        }}
      >
        {!!showClose && (
          <AppBar
            position="fixed"
            sx={{
              backgroundColor: "transparent",
              background: 'transparent',
              boxShadow: "none",
              height: "3.6rem",
            }}
          >
            <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
              <IconButton
                edge="end"
                color="inherit"
                aria-label="tracker"
                aria-describedby="close_icon_click"
                onClick={handleClose}
              >
                <CloseIcon htmlColor="#F8FAFF" aria-label="tracker"
                  aria-describedby="close_icon_click" />
              </IconButton>
            </Toolbar>
          </AppBar>
        )}
        {open ? children : null}
      </Dialog>
    </ThemeProvider>
  );
}
